import React from 'react'
import Component from './component'
import l10n from './l10n'

// make eager version of component (that doesn't lazy load itself) for use in block editor
const EagerComponent = props => <Component l10n={l10n} {...props} />

export default EagerComponent
